import { render, staticRenderFns } from "./aishortSign.vue?vue&type=template&id=ef17844c&scoped=true"
import script from "./aishortSign.vue?vue&type=script&lang=js"
export * from "./aishortSign.vue?vue&type=script&lang=js"
import style0 from "./aishortSign.vue?vue&type=style&index=0&id=ef17844c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef17844c",
  null
  
)

export default component.exports